import { createContext, useContext, useEffect, useState } from 'react';

type File = any;

type FileExplorerContextType = {
  current_file: File | null;
  set__current_file: (file: File) => void;

  is_editable: boolean;
  set__is_editable: (is_editable: boolean) => void;

  is_create_folder_open: boolean;
  set__is_create_folder_open: (is_open: boolean) => void;

  is_rename_modal_open: boolean;
  set__is_rename_modal_open: (is_open: boolean) => void;

  is_delete_modal_open: boolean;
  set__is_delete_modal_open: (is_open: boolean) => void;

  share_open: boolean;
  set__share_modal_open: (is_open: boolean) => void;

  is_moving_folder: string | null;
  open_move_to_folder_modal: (file_id: string) => void;
};

export const FileExplorerContext = createContext<
  FileExplorerContextType | undefined
>(undefined);

export const useFileExplorer = () => {
  const context = useContext(FileExplorerContext);

  if (context === undefined)
    throw new Error(
      `useFileExplorer must be used within a FileExplorerContextProvider.`
    );
  return context;
};

export interface Props {
  [propName: string]: any;
}

export const FileExplorerContextProvider = (props: Props) => {
  const [current_file, set__current_file] = useState<File | null>(null);
  const [is_editable, set__is_editable] = useState(true);
  const [is_create_folder_open, set__is_create_folder_open] = useState(false);
  const [is_rename_modal_open, set__is_rename_modal_open] = useState(false);
  const [is_delete_modal_open, set__is_delete_modal_open] = useState(false);
  const [share_open, set__share_modal_open] = useState(false);

  const [is_moving_folder, set__is_moving_folder] = useState<string | null>(null);

  useEffect(() => {
    if (!share_open) set__current_file(null);
  }, [share_open]);

  const value = {
    current_file,
    set__current_file,
    is_editable,
    set__is_editable,
    is_create_folder_open,
    set__is_create_folder_open,
    is_rename_modal_open,
    set__is_rename_modal_open,
    is_delete_modal_open,
    set__is_delete_modal_open,
    share_open,
    set__share_modal_open,
    is_moving_folder,
    open_move_to_folder_modal: (file_id: string) => set__is_moving_folder(file_id),
  };

  return <FileExplorerContext.Provider value={value} {...props} />;
};
